<template>
  <div class="content">
    <el-form :label-position="labelPosition" label-width="180px" :model="formInfo" ref="formInfo" :rules="rules"
             v-loading="loading"
             element-loading-text="The input data is being submitted, please wait……">
      <el-form-item label="1. Input fragments for your generation"
                    required>
        <el-form-item prop="fragment1" style="width: 300px;display: inline-block">
          <el-input v-model="formInfo.fragment1"  placeholder="input the fragment1" ></el-input>
        </el-form-item>
        <el-form-item prop="fragment2" style="margin-left:10px;width: 300px;display: inline-block">
          <el-input v-model="formInfo.fragment2"  placeholder="input the fragment2" ></el-input>
        </el-form-item>
<!--        <el-radio v-model="radio" label="1">-->
<!--          <div style="display: inline-block; vertical-align: middle">-->
<!--            <el-upload-->
<!--                class="upload-demo"-->
<!--                :on-preview="handlePreview"-->
<!--                :on-remove="handleRemove"-->
<!--                action=""-->
<!--                style="text-align: center;"-->
<!--                :http-request="httpRequest"-->
<!--                :before-remove="beforeRemove"-->
<!--                :multiple="false"-->
<!--                :limit="1"-->
<!--                :on-exceed="handleExceed"-->
<!--                :file-list="formInfo.fileList">-->
<!--              <el-button type="primary">Click to upload</el-button>-->
<!--            </el-upload>-->
<!--          </div>-->

<!--        </el-radio>-->

<!--        <br><br>-->
<!--        <el-radio v-model="radio" label="2">-->
<!--          <el-row style="display: inline-block; vertical-align: middle" :gutter="30">-->
<!--            <el-form-item prop="fragment1">-->
<!--            <el-col :span="12">-->
<!--              <div>-->
<!--                <el-row :gutter="20">-->
<!--                  <el-col :span="24">-->

<!--                  </el-col>-->
<!--                  <el-col :span="8">-->
<!--                    <el-button type="primary" plain>draw</el-button>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </div>-->
<!--            </el-col>-->
<!--            </el-form-item>-->
<!--            <el-col :span="12">-->
<!--              <div>-->
<!--                <el-row :gutter="20" >-->
<!--                  <el-col :span="24">-->
<!--                    <el-input v-model="formInfo.fragment2" prop="fragment2" placeholder="input the fragment2" ></el-input>-->
<!--                  </el-col>-->
<!--                  <el-col :span="8">-->
<!--                    <el-button type="primary" plain>draw</el-button>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </div>-->

<!--            </el-col>-->
<!--          </el-row>-->

<!--        </el-radio>-->
      </el-form-item>
      <el-form-item label="2. Select your desired properties for generating linkers (optional)">
        <el-row style="display: inline-block; vertical-align: middle" :gutter="30">
          <el-col :span="12">
            <div class="grid-content">
              <div class="grid-content">

                <el-form-item label="length">
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.length.min"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.length.max"></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item label="HBA">
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.HBA.min"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.HBA.max"></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <el-form-item label="AR">
                <el-col :span="11">
                  <el-form-item>
                    <el-input v-model="formInfo.properties.AR.min"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-form-item>
                    <el-input v-model="formInfo.properties.AR.max"></el-input>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="HBD">
                <el-col :span="11">
                  <el-form-item>
                    <el-input v-model="formInfo.properties.HBD.min"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-form-item>
                    <el-input v-model="formInfo.properties.HBD.max"></el-input>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="3. Enter the number of molecules you want to generate(optional, max = 100)."
                    prop="moleculesNumber"
      >
        <el-input v-model.number="formInfo.moleculesNumber"></el-input>
      </el-form-item>
      <el-form-item label="4. Please leave your email address and we will send the generated results to your email."
                    prop="email"

      >
        <el-input v-model="formInfo.email"></el-input>
        <span style="font-size: 12px; color: #909399; line-height: 1.5; display: block; margin-top: 4px;">
          Your uploaded data are used only for this task and are not shared or used for any other purpose. They are temporarily stored on our private server for up to six months.
        </span>
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" @click="submitForm">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
var sid=""
import OCL from 'openchemlib';
export default {
  name: "LinkerDesignForm",
  data() {
    return {
      loading:false,
      sid:sid,
      labelPosition: 'top',
      formInfo: {
        fileList: [],
        fragment1: '[*]C1=CC=C(C)C=C1',
        fragment2: '[*]C1=CC=CC=C1',
        properties: {
          HBA: {
            min: 0,
            max: 10
          },
          AR: {
            min: 0,
            max:3
          },
          length: {
            min: 2,
            max: 20
          },
          HBD: {
            min: 0,
            max: 5
          }
        },
        moleculesNumber: 20,
        email: ''
      },
      rules: {
        moleculesNumber: [
          // { message: 'The number of molecules cannot be empty'},
          {type: 'number', min:0,max:100,message: 'The number of molecules should be numerical.Range: 0~100.'}
        ],
        email: [
          {message: 'Please input the email address.', trigger: 'blur'},
          {type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change']}
        ],
        fragment1: [
          {required: true, message: 'Please input fragment1 for your generation.', trigger: 'blur'},
        ],
        fragment2: [
          {required: true, message: 'Please input fragment2 for your generation.', trigger: 'blur'},
        ]
      }
    };
  },
  methods: {
    handleRemove(file, fileList) {
      this.formInfo.fileList.pop();
      console.log(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The current limit is 1 file selected`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Confirmed to remove ${file.name}?`);
    },
    httpRequest(param) {
      console.log(param);
      this.formInfo.fileList.push(param.file);
    },
    checkSmiles(input)
    {
      const smiles = input;
      // 使用OCL解析SMILES序列
      try {
        const molecule = OCL.Molecule.fromSmiles(smiles);
        if (molecule === null) {
          return true
          // console.log('无效的SMILES序列');
        } else {
          console.log("SMILES"+molecule)
          return false
          // console.log('有效的SMILES序列');
        }
      } catch (error) {
        return true
        // console.log("eeeeeeeeeeeeeeeeee")
      }
    },
    submitForm() {

      const formData = new FormData();
      // if (this.radio == '1') {
      //   if (this.formInfo.fileList.length == 0) {
      //     this.$alert('Please upload file.');
      //     return;
      //   }
      //   formData.append('file', this.formInfo.fileList[0], this.formInfo.fileList[0].name);
      // } else {
      // }

      for (let [key, value] of Object.entries(this.formInfo.properties)) {
        console.log(value.min, value.max)
        // if (Number.isNaN(value.min) || Number.isNaN(value.max)) {
        //   this.$alert('Please input the correct number.');
        //   return;
        // }
        if (value.min>value.max)
        {
          this.$alert('Please enter the correct minimum and maximum values.');
          return;
        }
        formData.append(key, value.min + '-' + value.max);
      }
      formData.append("file", new File([''], 'nofile.txt'));

      //判断SMILES序列是否正确  返回true表示不合法，false表示合法
      if(this.checkSmiles(this.formInfo.fragment1))
      {
      //
        this.$alert("The data format of fragment1 is incorrect. Please re-enter.","Tips")
        return;
      }
      if(this.checkSmiles(this.formInfo.fragment2))
      {
        //
        this.$alert("The data format of fragment2 is incorrect. Please re-enter.","Tips")
        return;
      }


      this.$refs['formInfo'].validate((valid) => {
        if (valid) {
          this.loading=true

          console.log('submit');
          sid = require('uuid').v1()//生成uuid
          formData.append("num", this.formInfo.moleculesNumber);
          if(this.formInfo.email=='')
          {
            this.formInfo.email="2659381657@qq.com"
          }
          formData.append("email", this.formInfo.email);
          formData.append("fragment1",this.formInfo.fragment1);
          formData.append("fragment2",this.formInfo.fragment2)
          formData.append("uid", sid);
          // TODO: change the url
          var that=this
          axios.post("/generation/linker", formData).then(res => {
            this.loading=false
            console.log(res.data);
            if (res.data.code === 200){
              this.$router.push({
                path:'/generation/success',
                query:{
                  sid:sid
                }
              })
            }
          }).catch(err => {
            console.log(err);
            this.loading=false
            this.$alert('error submit!!');
            return false;
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-form-item {
  text-align: left;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}

.submit {
  text-align: center;
}

.grid-content {
  display: inline-block;
}

.line {
  text-align: center;
}

.button {
  display: inline-block;
}


</style>
